module.exports = __webpack_public_path__ + "img/ercode.8b3e67b3.png";